module.exports = __webpack_public_path__ + "img/logo_deputacion.4a8baa9d.webp";